import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { createContext, useContext, useMemo } from "react";
//Limitless imports
import { useDevLogging } from "../../../common/hooks/dev-logging/DevLoggingContext";
import { useCustomerHistory } from "./CustomerHistoryHook"; // Set the default state values for each context

var CustomerHistoryContext = createContext({});
export var CustomerHistoryContextProvider = function CustomerHistoryContextProvider(_ref) {
  var children = _ref.children;
  var hook = useCustomerHistory();

  var _useDevLogging = useDevLogging(),
      stateTracker = _useDevLogging.stateTracker;

  var context = useMemo(function () {
    stateTracker.trackState({
      history: hook.history
    });
    return _objectSpread({}, hook);
  }, [hook.history]); // pass the value in provider and return

  return /*#__PURE__*/React.createElement(CustomerHistoryContext.Provider, {
    value: context
  }, children);
};
export var useCustomerHistoryContext = function useCustomerHistoryContext() {
  return useContext(CustomerHistoryContext);
};